"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createSpaEntryfileUrl = require("./createSpaEntryfileUrl");
Object.keys(_createSpaEntryfileUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createSpaEntryfileUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createSpaEntryfileUrl[key];
    }
  });
});
